var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"card",staticClass:"background"},[_c('a-card',{staticClass:"card"},[_c('div',[_c('div',{staticClass:"logo-wrap"},[_c('img',{attrs:{"src":_vm.logo,"width":"100"}})]),_c('div',{staticClass:"title"},[_c('span',[_vm._v("RoadTrack")])]),_c('div',{staticClass:"subtitle"},[_c('span',[_vm._v("道路裂纹自动检测系统")])])]),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }